import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tailwind.css";
import App from "./js/App";
import { BrowserRouter } from "react-router-dom";
import store from "./js/store/index";
import { Provider } from "react-redux";
import { ThemeProvider } from "./js/context/ThemeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>,
);
